
import Vue from "vue";
import PlaceCard from "./place-card.vue";
export default Vue.extend({
  name: "place-cards-wrapper",
  props: ["floorPlan","placeIdHashList","gender","vacancy"],
  components: {
    PlaceCard,
  },
  computed: {
  },
});
